import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUsers(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATAASSIGN +
        // `?start_date=&end_date=&id=${payload.userId}&page=${payload.pageNo}&limit=${payload.pageSize}`,
        `?start_date=${payload.start_date}&end_date=${payload.end_date}&id=${payload.userId}&page=${payload.pageNo}&limit=${payload.pageSize}&search=${payload.search || ""}&formId=${payload.formId|| ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLead(
  userId: string,
  from: string,
  to: string,
  pageNo: any,
  pageSize: any
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA +
        `?start_date=${from}&end_date=${to}&id=${userId}&page=${pageNo}&limit=${pageSize}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamData(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamMembersData(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(`${urls.GETMEMBERSDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

const BULK_ASSIGN_BATCH = 250;
const BULK_ASSIGN_TIMEOUT_MS = 120000;

export async function assignLeadsToUser(
  payload: any,
  onProgress?: (done: number, total: number) => void
) {
  try {
    const rawLeadIds = String(payload?.lead_id || "")
      .split(",")
      .map((id) => id.replace(/['"]/g, "").trim())
      .filter(Boolean);

    const reportProgress = (done: number) =>
      onProgress?.(Math.min(done, rawLeadIds.length), rawLeadIds.length);

    if (rawLeadIds.length <= BULK_ASSIGN_BATCH) {
      reportProgress(0);
      const callParams = await getCallParams("POST", payload);
      const res = await makeCall(
        `${urls.ASSIGNLEADSTOMEMBERS}`,
        callParams,
        BULK_ASSIGN_TIMEOUT_MS
      );
      reportProgress(rawLeadIds.length);
      return res;
    }

    let ok = 0;
    let fail = 0;
    let lastMessage = "";

    for (let i = 0; i < rawLeadIds.length; i += BULK_ASSIGN_BATCH) {
      const batch = rawLeadIds.slice(i, i + BULK_ASSIGN_BATCH);
      reportProgress(i);
      const batchPayload = {
        ...payload,
        lead_id: batch.map((id) => `'${id}'`).join(","),
      };
      const callParams = await getCallParams("POST", batchPayload);
      const res = await makeCall(
        `${urls.ASSIGNLEADSTOMEMBERS}`,
        callParams,
        BULK_ASSIGN_TIMEOUT_MS
      );

      if (!(res?.success === 1 || res?.success === true)) {
        reportProgress(i + batch.length);
        return {
          ...res,
          message:
            res?.message ||
            `Re-assign failed at batch ${Math.floor(i / BULK_ASSIGN_BATCH) + 1}`,
          data: { ok, fail, total: rawLeadIds.length },
        };
      }

      ok += Number(res?.data?.ok ?? batch.length);
      fail += Number(res?.data?.fail ?? 0);
      lastMessage = res?.message || lastMessage;
      reportProgress(i + batch.length);
    }

    return {
      success: 1,
      message: fail
        ? `Re-assigned ${ok} lead(s), ${fail} failed`
        : lastMessage || `Re-assigned ${ok} lead(s) successfully`,
      data: { ok, fail, total: rawLeadIds.length },
    };
  } catch (error) {
    throw error;
  }
}
export async function getAllTeam() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllStage() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllSource() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSOURSE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStage(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATESTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function changeAt(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEAI, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveReminder(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function assignToMembers(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ASSIGNTOMEMBERS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.UPDATEREMINDER + `/${id?.id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
